import { call, put, takeEvery, all, fork } from "redux-saga/effects"

// Calender Redux States
import {
  GET_BANNERS,
  ADD_NEW_BANNER,
  GET_BANNER_DETAILS,
  UPDATE_BANNER,
  DELETE_BANNER,
} from "./actionTypes"

import {
  getBannersSuccess,
  getBannersFail,
  addNewBannerSuccess,
  addNewBannerFail,
  getBannerDetailsSuccess,
  getBannerDetailsFail,
  updateBannerSuccess,
  updateBannerFail,
  deleteBannerSuccess,
  deleteBannerFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getBannerList,
  addNewBanner,
  getBannerDetails,
  updateBanner,
  delBanner
} from "../../helpers/fakebackend_helper"

function* fetchBanners({ payload: banner }) {
  try {
    const response = yield call(getBannerList, banner)
    yield put(getBannersSuccess(response))
  } catch (error) {
    yield put(getBannersFail(error))
  }
}

export function* watchFetchBanners() {
  yield takeEvery(GET_BANNERS, fetchBanners);
}

function* onAddNewBanner({ payload: banner }) {
  try {
      const response = yield call(addNewBanner, banner);
      if(response.status === 200){
        yield put(addNewBannerSuccess(response));
      } else {
        yield put(addNewBannerFail(response));
      }
  } catch (error) {
      yield put(addNewBannerFail(error));
  }
}

export function* watchAddNewBanner() {
  yield takeEvery(ADD_NEW_BANNER, onAddNewBanner);
}

function* onBannerDetails({ payload: banner }) {
  try {
      const response = yield call(getBannerDetails, banner);
      if(response.status === 200){
        yield put(getBannerDetailsSuccess(response));
      } else {
        yield put(getBannerDetailsFail(response));
      }
  } catch (error) {
      yield put(getBannerDetailsFail(error));
  }
}

export function* watchBannerDetails() {
  yield takeEvery(GET_BANNER_DETAILS, onBannerDetails);
}

function* onBannerUpdate({ payload: banner }) {
  try {
      const response = yield call(updateBanner, banner);
      if(response.status === 200){
        yield put(updateBannerSuccess(response));
      } else {
        yield put(updateBannerFail(response));
      }
  } catch (error) {
      yield put(updateBannerFail(error));
  }
}

export function* watchUpdateBanner() {
  yield takeEvery(UPDATE_BANNER, onBannerUpdate);
}

function* onDeleteBanner({payload : data}) {
  try {
    const response = yield call(delBanner,data)
    yield put(deleteBannerSuccess(response))
  } catch (error) {
    yield put(deleteBannerFail(error))
  }
}

export function* watchDeleteBanner() {
  yield takeEvery(DELETE_BANNER, onDeleteBanner);
}


function* bannerSaga() {
  yield all(
    [
      fork(watchFetchBanners),
      fork(watchAddNewBanner),
      fork(watchBannerDetails),
      fork(watchUpdateBanner),
      fork(watchDeleteBanner),
    ]
  );

}

export default bannerSaga
